export default {
  bgMusic: 'BGM',
  bgImage: '背景画像',
  bgColor: '背景の色',
  defaultLanguage: 'デフォルトの言語',
  colorChoose:
    '背景の色と背景画像が同時に存在する場合、優先的に背景の色が表示されます',
  languageChoose:
    '広告投稿中、素材パッケージに含まれる言語がデバイスの言語と一致しない場合、デフォルトの言語が使用されます',
  bgmTipsContent: 'MP3形式に対応、サイズは2Mを超えてはいけません',
  bgImgTipsContent: 'PNG/JPG形式に対応',
  tip: 'ヒント',
  orNotDeleteBgImg: '背景画像を削除しますか？',
  cancelBtn: 'キャンセル',
  confirmBtn: '確認',
  gameLoadMessage: 'ゲームがまだ読み込まれていません',
  bgColorMessage:
    '設定された背景色は背景画像で置き換えることはできません。まず背景色を削除してください',
  cancelDelete: '削除がキャンセルされました',
  deleteSuccess: '削除成功！',
  uploadSuccess: 'アップロード完了！',
  addBgmWarning: 'BGMが追加されていません。まず追加してください',
  orNotDeleteBgm: 'BGMを削除しますか？',
  backgroundAudio: {
    replaceBtn: '置き換え',
    cutterBtn: '編集',
    volume: '音量',
    bgmInfoDuration: '取得中...',
    fileSizeMessage: 'BGMファイルの容量は2M以内にしてください',
    fileExtMessage: 'MP3形式の音声のみアップロード可能',
  },
  backgroundImage: {
    uploadBtn: '置き換え',
    cropBtn: '編集',
    filter: 'フィルター',
    cropSuccess: 'クロップが完了しました！',
    filterSuccess: 'フィルターの変更が完了しました',
  },
  backgroundColor: {
    single: '単色',
    gradient: 'グラデーション',
    toggleMessage: 'ゲームがまだ読み込まれていません',
  },
  language: {
    editBtn: '言語の変更',
    deleteBtn: '言語の削除',
    addBtn: '言語の追加',
    deleteConfirm: '削除を確認しますか？',
    dialog: {
      addLanguage: '言語の追加',
      selectLanguage: '言語の選択',
      closeBtn: 'キャンセル',
      submitBtn: '提出',
      contentNotEmpty: '地域/言語を選択してください',
    },
  },
  tabBarList: {
    design: '外観',
    animation: 'アニメーション',
    scene: 'シーン設定',
    global: 'グローバル設定',
    event: 'イベント',
    gameConfig: 'ゲームプレイのパラメータ',
  },
}
